import React from 'react';
import { Button, Dialog, DialogActions, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import {
  AudioDeviceSelector,
  DeviceSelector,
  VideoDeviceSelector,
} from '../../ControlsClient/DeviceSelector/DeviceSelector';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles<Theme>(theme => ({
  container: {
    width: '350px',
    minHeight: '180px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
  },
  button: {
    float: 'right',
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
}));

export default function DeviceDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <DeviceSelector className={classes.container} />
      <DialogActions>
        <Button className={classes.button} onClick={onClose}>
          {t('Done')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function AudioDeviceDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <AudioDeviceSelector className={classes.container} />
      <DialogActions>
        <Button className={classes.button} onClick={onClose}>
          {t('Done')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function VideoDeviceDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <VideoDeviceSelector className={classes.container} />
      <DialogActions>
        <Button className={classes.button} onClick={onClose}>
          {t('Done')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
